<bgo-pro-directory
  [filter]="{region, industryIds: industryId ? [industryId.toString()] : undefined}"
  [title]="region.regionName"
  (searchEnd)="total = $event.total"
  class="h-content-layout"
  *transloco="let t"
>
  <p role="heading" aria-level="2" content="heading">
    <span class="plot-lg">
      {{ t('proDirectoryByRegion.resultTitleAmount', {amount: total}) }}
    </span>
  </p>
</bgo-pro-directory>
